/**
 * @generated SignedSource<<6db47c679c13ca061a609475ded8344e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EraseOrderAttributionInput = {
  clientMutationId?: string | null;
  orderId: string;
};
export type eraseAttributionAction_EraseOrderAttributionMutation$variables = {
  input: EraseOrderAttributionInput;
};
export type eraseAttributionAction_EraseOrderAttributionMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly eraseOrderAttribution: {
        readonly erasedOrderIds: ReadonlyArray<string>;
        readonly orderId: string;
      } | null;
    };
  };
};
export type eraseAttributionAction_EraseOrderAttributionMutation = {
  response: eraseAttributionAction_EraseOrderAttributionMutation$data;
  variables: eraseAttributionAction_EraseOrderAttributionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Billing",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "EraseOrderAttributionPayload",
            "kind": "LinkedField",
            "name": "eraseOrderAttribution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "erasedOrderIds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eraseAttributionAction_EraseOrderAttributionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eraseAttributionAction_EraseOrderAttributionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6d5ace8a044a54318c91a38849f42367",
    "id": null,
    "metadata": {},
    "name": "eraseAttributionAction_EraseOrderAttributionMutation",
    "operationKind": "mutation",
    "text": "mutation eraseAttributionAction_EraseOrderAttributionMutation(\n  $input: EraseOrderAttributionInput!\n) {\n  Admin {\n    Billing {\n      eraseOrderAttribution(input: $input) {\n        orderId\n        erasedOrderIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5845b12bd6aecdc25972eea3111043b7";

export default node;
